// import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
// import { Observable } from 'rxjs';
// import { StorageService } from 'src/app/Core/_services/storage/storage.service';
// import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';
// export class logoutGuard implements CanActivate {
//   // constructor(
//   //   private router: Router,
//   //   private authService: AuthService,
//   //   private storage: StorageService
//   // ) {}
//   // canActivate(route: ActivatedRouteSnapshot): any {
//   //   this.authService.logout()
//   //   return false
//   //   // const userData = this.storage.userData;
//   //   // let role = this.storage.userData.seller.is_agent ? 'agent' : 'seller';
//   //   // let temp: any = route;
//   //   // let roles: string[] = temp.data.roles;
//   //   // console.log('roles', roles,role);
//   //   // let hasAccess: boolean;
//   //   // if (!roles) {
//   //   //   hasAccess = true;
//   //   // } else if (roles.length && role.includes(role)) {
//   //   //   hasAccess = true;
//   //   // } else {
//   //   //   hasAccess = false;
//   //   // }

//   //   // if (
//   //   //   this.authService.isLoggedInAndAuthorized() &&
//   //   //   userData?.seller?.completed_at &&
//   //   //   userData.mobile_verified_at &&
//   //   //   userData.temp_password_changed
//   //   //   // &&
//   //   //   // hasAccess
//   //   // ) {
//   //   //   return true;
//   //   // } else {
//   //   //   this.storage.clearStorage();
//   //   //   this.router.navigate(['/seller/auth/login']);
//   //   //   return false;
//   //   // }
//   // }

//   constructor(
//      private authService: AuthService,

//     private router: Router
//   ) {}

//   canActivate(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
//     this.authService.logout()
//     return true
//     // Perform action before navigating
//     // return this.navigationConfirmationService.confirm().pipe(
//     //   map(confirmed => {
//     //     if (confirmed) {
//     //       return true;  // Allow navigation
//     //     } else {
//     //       this.router.navigate(['/']);  // Navigate to another page or stay on current page
//     //       return false;  // Prevent navigation
//     //     }
//     //   })
//     // );
//   }
// }
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogoutGuard implements CanActivate {
  isBrowser: boolean;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  canActivate(): boolean {
    // Perform action like clearing storage and redirecting
    if (this.isBrowser) {
      localStorage.clear();
      window.location.href = environment.wordpressUrl; // External URL
    }
    // Prevent default route navigation
    return false;
  }
}
